const state = {
	zcoolImgData: []
}
const mutations = {
	SET_ZCOOL_IMG_DATA(state, data) {
		state.zcoolImgData = data
	}
}
const getters = {}
const actions = {}

export default { state, mutations, getters, actions, namespaced: true}
